"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var RadixToggleGroup = _interopRequireWildcard(require("@radix-ui/react-toggle-group"));
require("focus-visible");
var _classnames = _interopRequireDefault(require("classnames"));
var _ToggleGroupModule = _interopRequireDefault(require("./ToggleGroup.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ToggleGroup = exports.ToggleGroup = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var className = _ref.className,
    options = _ref.options,
    selection = _ref.selection,
    onSelectionChange = _ref.onSelectionChange,
    _ref$isRequired = _ref.isRequired,
    isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$selectionType = _ref.selectionType,
    selectionType = _ref$selectionType === void 0 ? 'single' : _ref$selectionType;
  var handleOnValueChange = (0, _react.useCallback)(selection => {
    if (isRequired && (!selection || selection.length === 0)) {
      return;
    }
    onSelectionChange(selection);
  }, [onSelectionChange, isRequired]);
  return /*#__PURE__*/_react.default.createElement(RadixToggleGroup.Root, {
    ref: ref,
    className: (0, _classnames.default)(_ToggleGroupModule.default.Container, className),
    type: selectionType,
    value: selection,
    onValueChange: handleOnValueChange,
    "data-disabled": isDisabled ? '' : undefined
  }, options.map(option => /*#__PURE__*/_react.default.createElement(Option, {
    option: option,
    key: option.key,
    isGroupDisabled: isDisabled
  })));
});
var Option = _ref2 => {
  var option = _ref2.option,
    isGroupDisabled = _ref2.isGroupDisabled;
  var isIcon = 'icon' in option;
  return /*#__PURE__*/_react.default.createElement(RadixToggleGroup.Item, {
    disabled: isGroupDisabled || option.isDisabled,
    className: (0, _classnames.default)(_ToggleGroupModule.default.Toggle),
    key: option.key,
    value: option.key,
    "data-type": isIcon ? 'icon' : 'text'
  }, isIcon ? option.icon : /*#__PURE__*/_react.default.createElement("span", null, option.label));
};
//# sourceMappingURL=ToggleGroup.js.map